<template>
  <div class="detail-shell d-flex flex-column h-100 overflow-hidden align-items-stretch flex-grow-1">
    <div class="action-bar d-flex flex-row align-items-center gap-0 flex-shrink-0 border-bottom">
      <slot name="top" />
    </div>

    <template v-if="ready">
      <slot name="after-top" />
      <div class="detail-shell-main d-flex flex-row flex-grow-1 overflow-hidden align-items-stretch">
        <div class="detail-shell-left d-flex flex-column flex-grow-1 overflow-hidden">
          <slot name="left" />
        </div>
        <div v-if="showPanel" class="detail-shell-panel d-flex flex-column border-start">
          <div class="flex-grow-1 overflow-auto">
            <slot name="right" />
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <slot name="fallback" />
    </template>
  </div>
</template>

<script>
export default {
  props: {
    ready: {
      type: Boolean,
      default: true
    },
    showPanel: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.action-bar :deep(.btn) {
  border-radius: 0;
}

.detail-shell-main {
  position: relative;
}

.detail-shell-panel {
  width: 50%;
  max-width: 450px;
  min-width: 300px;
  flex-shrink: 0;
}

@media (max-width: 767px) {
  .detail-shell-panel {
    width: 100%;
    max-width: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    z-index: 10;
  }
}
</style>
